import { CmsConfirmDialog } from "../CmsConfirmDialog/CmsConfirmDialog";
import styles from "./MultipleFirmTagsModal.module.css";

type MultipleFirmTagsModalProps = {
  firmNames: string[];
  onConfirm: () => void;
  onCancel: () => void;
};

export function MultipleFirmTagsModal({
  firmNames,
  onConfirm,
  onCancel,
}: MultipleFirmTagsModalProps) {
  return (
    <CmsConfirmDialog
      title="More than one firm tagged"
      message="This text tags more than one firm:"
      detail={
        <>
          <ul className={styles.firmList}>
            {firmNames.map(name => (
              <li key={name}>{name}</li>
            ))}
          </ul>
          <p className={styles.guidance}>
            Editorial content should tag only one firm. Mention other firms as plain text.
          </p>
        </>
      }
      confirmLabel="Save anyway"
      cancelLabel="Go back"
      tone="warning"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
